// src/components/Tooltip
import React from 'react';
import { Container } from './styles';

interface TooltipProps {
  title: string;
  className?: string;
}

const Tooltip: React.FC<TooltipProps> = ({ title, className }) => {
  return (
    <Container className={className}>
      <span>{title}</span>
    </Container>
  );
};

export default Tooltip;
